import { render, staticRenderFns } from "./Comision.vue?vue&type=template&id=6e1e49b1"
import script from "./Comision.vue?vue&type=script&lang=ts"
export * from "./Comision.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports